import { render, staticRenderFns } from "./SubCollection.vue?vue&type=template&id=32b4b2f6&"
import script from "./SubCollection.vue?vue&type=script&lang=js&"
export * from "./SubCollection.vue?vue&type=script&lang=js&"
import style0 from "./SubCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports